/** Workflow 大规模编排 UI 缩放选项（P1–P4） */
export interface WorkflowScaleOptions {
  /**
   * P1：已弃用 — stage 壳列表不再使用虚拟滚动。
   * 保留字段以保证向后兼容，工作流主链路不再读取此值。
   * @deprecated D25 Phase 1 移除 stage shell virtualization 后不再生效。
   */
  stageVirtualizeThreshold: number;
  /** P3：默认展示的 completed done stage 上限（running/failed/pending 始终展示） */
  completedStagePageSize: number;
  /** P2：completed 且未 pin 的 loop 树移出内存，保留摘要 */
  evictCompletedLoops: boolean;
  /** P4：历史选项；折叠不变式不再因 non-active 隐藏 running 容器（见 workflow-display-rules §8） */
  onlyExpandActiveRunning: boolean;
  /**
   * P1：已弃用 — parallel item shell 不再使用虚拟滚动（最大并行跨度仅 4）。
   * 保留字段以保证向后兼容，工作流主链路不再读取此值。
   * @deprecated D25 Phase 1 移除 parallel item virtualization 后不再生效。
   */
  parallelItemVirtualizeThreshold: number;
  /** P2：completed hydrated loop 热缓存上限（默认 4，与最大并行跨度对齐） */
  maxHydratedCompletedLoops: number;
}

export const DEFAULT_WORKFLOW_SCALE_OPTIONS: WorkflowScaleOptions = {
  stageVirtualizeThreshold: 40,
  completedStagePageSize: 25,
  evictCompletedLoops: true,
  onlyExpandActiveRunning: true,
  parallelItemVirtualizeThreshold: 40,
  maxHydratedCompletedLoops: 4,
};
